import { ComponentPropsWithoutRef } from 'react'
import { clsx } from '@unbridaled/shared/utils/clsx'

export type ModalContentProps = ComponentPropsWithoutRef<'div'>

export const ModalContent = ({ children, className, ...props }: ModalContentProps): React.ReactNode => (
  <div data-slot="content" className={clsx('uui-py-4 uui-px-6', className)} {...props}>
    {children}
  </div>
)
